/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { toast } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ContactApi } from "../../../api/Contacts";
import { RefreshCampaignContacts } from "../../../atoms/CampaignsContactsModalAtom";
import { LabelAtom } from "../../../atoms/LabelAtom";
import { TagsAtom } from "../../../atoms/TagsAtom";
import { ResetSearchAtom } from "../../../pages/contacts";
import { SettingsTab } from "../../../pages/settings";
import { SpaceBetween } from "../../../styles/general";
import { ContactStatus, IContact } from "../../../types/Contact";
import { ITag } from "../../../types/TagTypes";
import { validationEmail } from "../../../utils/Validation";
import LabelSelect from "../../Label/LabelSelects";
import StyledButton from "../../StyledButton";
import StyledInput from "../../StyledInput";
import TagSelect from "../../TagSelect/TagSelect";
import { useModal } from "../Modal";
import Warning from "./Warning";

const ModalBody = styled.div<{ testDriveContactMode?: boolean }>`
  max-width: 480px;
  min-width: 480px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  border-top: 1px solid #eceeee;

  margin: 20px -22px -25px;

  ${(props) =>
    props.testDriveContactMode &&
    css`
      border: none;

      > div {
        border: none;
        padding-top: 0px;
      }
    `}
`;

const Wrapper = styled.div<{ testDriveContactMode?: boolean }>`
  width: 100%;
  height: ${(props) => (props.testDriveContactMode ? "100%" : "400px")};

  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: auto;

  > div + div {
    margin-top: 24px;
  }
`;

const Buttons = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  border-top: 1px solid #eceeee;

  padding: 20px;
`;

const FormGroup = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .ekp3u414 {
    width: 80px;
    height: 40px;
    margin-left: 10px;
  }

  .envmntf9 {
    margin: 16px 0 0 0;
    grid-gap: 16px;

    > div {
      margin: 0;
    }
  }

  .react-tel-input .form-control {
    width: 100%;
    height: 40px;
    border: 1px solid #dddddd;
    border-radius: 5px;
    outline: none;
    font-size: 15px;
    color: #383838;

    :focus {
      box-shadow: 0px 0px 6px #fb972e80;
      border: 1px solid #fb972e;
    }
  }

  .react-tel-input .selected-flag:focus:before,
  .react-tel-input .selected-flag.open:before {
    box-shadow: none;
    border: none;
    outline: none;
  }

  .react-tel-input .country-list {
    width: 360px;
  }

  > div:last-of-type {
    width: 100%;
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #2f2f2f;

  margin-bottom: 16px;
`;

const Action = styled.div`
  display: flex;
  align-items: center;
  color: #fb972e;
  font-weight: 400;
  margin-bottom: 5px;
  cursor: pointer;
`;

const LabelFormGroup = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ActionIcon = styled(motion.img)`
  width: 10px;
  height: 10px;
`;

const marginRight5 = css`
  margin-right: 5px;
`;

const marginLeft5 = css`
  margin-left: 5px;
`;

export enum ShowTagState {
  ADD,
  SHOW,
  HIDE,
}

type Props = {
  testDriveContactMode?: boolean;
  onTestDriveContactCreated?: () => Promise<void>;
  emailUser?: string;
  emailAlias?: string;
  emailContact?: string;
  handleChangeEmailContact?: (vle: string) => void;
  isEditTestDrive?: boolean;
  testDriveContact?: IContact;
  emailFromTest?: string; //This email is coming from sent email test when there is no contact with this email
  isCampaignContacts?: boolean;
  isEdit?: boolean;
  contact?: IContact;
};

export default function AddContact(props: Props): JSX.Element {
  const modal = useModal();
  const router = useRouter();
  const labels = useRecoilValue(LabelAtom);
  const tagsPool = useRecoilValue(TagsAtom);
  const [actionTag, setActionTag] = useState<ShowTagState>(ShowTagState.ADD);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  let [email, setEmail] = useState(props?.emailFromTest || "");
  let [phone, setPhone] = useState("");
  const setResetSeach = useSetRecoilState(ResetSearchAtom);
  const [selectLabels, setSelectedLabels] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState<ITag[]>([]);
  const setRefreshCampaignContacts = useSetRecoilState(RefreshCampaignContacts);
  const [danielContactPasscode, setDanielContactPasscode] = useState(null);
  // SAD USEEFFECT
  useEffect(() => {
    //
    if (!props.isEdit) return;
    //@ts-ignore
    if (props?.contact?.userUid !== "ZHYBlalzKgeyNyXrb9Qakrfho2D3") return;

    (async () => {
      const response = await fetch(
        //@ts-ignore
        `https://persuasive-page-crm-integration.lrnit.pro/crm/berserker_mail/get_passcode?email=${props?.contact?.email}`
      );

      const data = await response.json();

      setDanielContactPasscode(data?.passcode);
    })();
    //@ts-ignore
  }, [props?.contact]);

  useEffect(() => {
    if (props.isEdit) {
      const { contact } = props as any;
      // const [firstName, lastName] = contact.name.split(" ");
      setFirstName(contact.firstName || "");
      setLastName(contact.lastName || "");

      setEmail(contact.email);
      setSelectedLabels(contact.labels);

      if (contact.phone) {
        setPhone(contact.phone);
      }

      const contactTags = contact.tags
        .map((tag) => tagsPool.find((t) => t._id === tag._id))
        .filter((t) => !!t) as ITag[];

      // If the user has tags, already show them
      if (contactTags.length > 0) {
        setSelectedTags(contactTags);
        setActionTag(ShowTagState.SHOW);
      }
    }
  }, []);

  async function handleConfirmClick() {
    setIsLoading(true);
    let emailTest;

    if (props?.testDriveContactMode) {
      emailTest = props.emailContact.trim();

      if (emailTest.includes("+")) {
        toast(
          "BerserkerMail does not allow the '+keyword' based alias emails. Instead of entering troy+test@troybroussard.com you will need to enter troy@troybroussard.com as the email address. For CAN-SPAM reasons we cannot alter the email you enter, so you'll need to re-enter it.",
          { type: "error" }
        );
        setIsLoading(false);
        return;
      }

      if (!validationEmail(emailTest)) {
        toast("Incorrect email format", { type: "error" });
        setIsLoading(false);
        return;
      }

      if (emailTest === props.emailAlias) {
        toast("This contact cannot be the same as your send email address.", {
          type: "error",
        });
        setIsLoading(false);
        return;
      }
    } else {
      emailTest = email.trim();

      if (emailTest.includes("+")) {
        toast(
          "BerserkerMail does not allow the '+keyword' based alias emails. Instead of entering troy+test@troybroussard.com you will need to enter troy@troybroussard.com as the email address. For CAN-SPAM reasons we cannot alter the email you enter, so you'll need to re-enter it.",
          { type: "error" }
        );
        setIsLoading(false);
        return;
      }

      if (!validationEmail(emailTest)) {
        toast("Incorrect email format", { type: "error" });
        setIsLoading(false);
        return;
      }
    }

    if (props.isEdit && props.contact) {
      const { contact } = props;

      let newContactTags = [
        ...selectedTags.map((t) => {
          const contactAlreadyHasTag = contact.tags.find(
            (tag) => tag._id === t._id
          );

          return {
            _id: t._id,
            appliedAt: contactAlreadyHasTag
              ? contactAlreadyHasTag.appliedAt
              : new Date(),
          };
        }),
      ];

      let editContact = {
        name: `${firstName + " " + lastName}`,
        firstName,
        lastName,
        email: emailTest,
        labels: selectLabels,
        tags: newContactTags,
        avatar: "",
        phone,
      };

      try {
        let result = await ContactApi.update(editContact, contact._id);

        if (result.count > 0) {
          // THIS IS UGLY, I'm creating a contact right here
          // to add to the array

          // This contact was updated
          setResetSeach((v) => !v);
          modal.popModal();
        }
      } catch (err) {
        if (err.message === "CONTACT_ALREADY_EXISTS") {
          toast("A contact with this email address already exists", {
            type: "warning",
          });
        }
      }
    } else {
      try {
        if (props.isEditTestDrive) {
          let result = await ContactApi.update(
            { ...props.testDriveContact, email: props.emailContact },
            props.testDriveContact._id
          );

          if (props.onTestDriveContactCreated)
            await props.onTestDriveContactCreated();

          setIsLoading(false);

          return;
        }

        const newTags = selectedTags.map((t) => t._id!);

        let newContact = {
          name: `${firstName + " " + lastName}`,
          firstName,
          lastName,
          email: emailTest,
          labels: selectLabels,
          status: ContactStatus.NOT_CONFIRMED,
          tags: newTags,
          avatar: "",
          phone,
        };

        // Creating new contact
        const responseContact = await ContactApi.create(newContact);

        if (responseContact) {
          setResetSeach((v) => !v);

          if (props.testDriveContactMode) {
            await ContactApi.setDefaultTestDrive({
              contactId: responseContact._id,
            });

            if (props.onTestDriveContactCreated)
              await props.onTestDriveContactCreated();
          }

          modal.popModal();
        } else {
          // If the contact was blocked - gets here
          modal.popModal();

          modal.pushModal(
            <Warning
              title="You cannot add this contact"
              description="The contact you tried to add is blocked by the rules you have set. Change those rules before trying to add this contact again."
              buttonsName={["Go to Blocking", "Ok"]}
              icon={"./icons/modal/block-user.svg"}
              onCancelClicked={() => {
                router.push(`/settings?screen=${SettingsTab.BLOCKING}`);
                modal.popModal();
              }}
              onOkClicked={() => modal.popModal()}
            />
          );
        }
      } catch (err) {
        if (err.message === "CONTACT_ALREADY_EXISTS") {
          toast("A contact with this email address already exists", {
            type: "warning",
          });
        }
        if (err.message === "CONTACT_EMAIL_DOMAIN_SUPRESSSED") {
          toast("The domain of the email is not supported", {
            type: "warning",
          });
        }
      }
    }
    props.isCampaignContacts &&
      setRefreshCampaignContacts((prevState) => !prevState);
    setIsLoading(false);
  }

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        handleConfirmClick();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [firstName, lastName, email, phone, selectLabels]);

  return (
    <ModalBody testDriveContactMode={props.testDriveContactMode}>
      <Wrapper testDriveContactMode={props.testDriveContactMode}>
        {!props.testDriveContactMode && (
          <FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Title>First Name</Title>
              <Title
                style={{ opacity: 0.3, fontWeight: "normal", fontSize: 14 }}
              >
                optional
              </Title>
            </div>
            <StyledInput
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Enter first name"
            />
          </FormGroup>
        )}

        {!props.testDriveContactMode && (
          <FormGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Title>Last Name</Title>
              <Title
                style={{ opacity: 0.3, fontWeight: "normal", fontSize: 14 }}
              >
                optional
              </Title>
            </div>
            <StyledInput
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Enter last name"
            />
          </FormGroup>
        )}

        <FormGroup>
          <Title>Email Address</Title>
          <StyledInput
            error={
              props?.onTestDriveContactCreated
                ? props?.emailUser === props.emailContact
                : false
            }
            value={
              props?.onTestDriveContactCreated ? props.emailContact : email
            }
            onChange={(e) => {
              if (props?.onTestDriveContactCreated) {
                props.handleChangeEmailContact(
                  e.target.value.split(" ").join("")
                );
              } else setEmail(e.target.value.split(" ").join(""));
            }}
            placeholder="Enter email address"
          />
        </FormGroup>

        {!props.testDriveContactMode && (
          <>
            <FormGroup>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Title>Phone</Title>
                <Title
                  style={{ opacity: 0.3, fontWeight: "normal", fontSize: 14 }}
                >
                  optional
                </Title>
              </div>
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(e, data, event, form) => {
                  /* This lib accepts the country code as zero and to fix this you have to change the value directly in the html 
               because the value attribute is only used in the mount */
                  if (form.startsWith("+0")) {
                    form = form.replace("+0", "+1");
                    let phoneInputElement = document.querySelector(
                      ".form-control"
                    ) as HTMLInputElement | null;

                    if (phoneInputElement) {
                      phoneInputElement.value = form;
                    }
                  }

                  setPhone(form);
                }}
              />
            </FormGroup>
            {danielContactPasscode && (
              <FormGroup>
                <Title>LRN Passcode</Title>
                <StyledInput
                  // @ts-ignore
                  value={danielContactPasscode}
                  disabled={true}
                />
              </FormGroup>
            )}
            <FormGroup>
              <SpaceBetween>
                <Title>Tags</Title>
                {actionTag === ShowTagState.ADD ? (
                  <Action onClick={() => setActionTag(ShowTagState.SHOW)}>
                    <ActionIcon src={"./icons/plus.svg"} css={marginRight5} />
                    Add
                  </Action>
                ) : (
                  <Action
                    onClick={() => {
                      if (actionTag === ShowTagState.SHOW)
                        setActionTag(ShowTagState.HIDE);
                      else setActionTag(ShowTagState.SHOW);
                    }}
                  >
                    {actionTag === ShowTagState.SHOW ? "Hide" : "Show"}
                    <ActionIcon
                      css={marginLeft5}
                      src={"./icons/caret-down.svg"}
                      animate={
                        actionTag === ShowTagState.SHOW
                          ? { rotate: 180 }
                          : { rotate: 0 }
                      }
                      transition={{ ease: "easeOut", duration: 0.3 }}
                    />
                  </Action>
                )}
              </SpaceBetween>
              {actionTag === ShowTagState.SHOW && (
                <TagSelect
                  tags={selectedTags}
                  preserveSystemTags={true}
                  handleChoseTags={(tags) => setSelectedTags(tags)}
                />
              )}
            </FormGroup>

            <LabelFormGroup>
              <Title
                css={css`
                  margin-bottom: 0;
                `}
              >
                Labels
              </Title>
              <LabelSelect
                noFilter
                above
                leftDirection
                customCss={css`
                  margin-left: 0;
                  .labelpopover {
                    max-height: 340px;
                  }
                `}
                activeLabels={
                  labels?.filter((l) => selectLabels.includes(l._id)) || []
                }
                selectLabelHandler={(label) =>
                  setSelectedLabels((ls) =>
                    ls.includes(label._id)
                      ? ls.filter((l) => l !== label._id)
                      : [...selectLabels, label._id as string]
                  )
                }
              />
            </LabelFormGroup>
          </>
        )}
      </Wrapper>

      <Buttons>
        {!props.testDriveContactMode && (
          <>
            <StyledButton
              inverted
              css={css`
                width: 80px;
                margin-right: 10px;
              `}
              onClick={() => modal.popModal()}
            >
              Cancel
            </StyledButton>
            <StyledButton
              css={css`
                width: 80px;
              `}
              isLoading={isLoading}
              disable={email.trim() === ""}
              onClick={handleConfirmClick}
            >
              {props.isEdit ? "Save" : "Add"}
            </StyledButton>
          </>
        )}

        {props.testDriveContactMode && (
          <StyledButton
            css={
              props.testDriveContactMode
                ? css`
                    width: 100%;
                  `
                : css`
                    width: 100%;
                    margin-bottom: 20px;
                  `
            }
            isLoading={isLoading}
            disable={
              props.testDriveContactMode
                ? props.emailContact.trim() === ""
                : email.trim() === ""
            }
            onClick={handleConfirmClick}
          >
            {props.testDriveContactMode
              ? "Set your Test Drive contact"
              : "Create Test Drive contact"}
          </StyledButton>
        )}
      </Buttons>
    </ModalBody>
  );
}
